export default [
  {
    label: 'Connector',
    value: 'connector',
    icon:  'icon-domo-connector',
  },
  {
    label: 'Dashboard',
    value: 'dashboard',
    icon:  'icon-domo-pages',
  },
  {
    label: 'Data Science',
    value: 'data_science',
    icon:  'icon-domo-arrow-fork',
  },
  {
    label: 'Dataflow',
    value: 'dataflow',
    icon:  'icon-domo-arrow-fork',
  },
  {
    label: 'Enterprise App',
    value: 'enterprise_app',
    icon:  'icon-domo-select-chart',
  },
  {
    label: 'Writeback',
    value: 'writeback',
    icon:  'icon-domo-wrench',
  },
  {
    label: 'Federated Data',
    value: 'federated_data',
    icon:  'icon-domo-federated-data',
  },
  {
    label: 'Code Block',
    value: 'code_block',
    icon:  'icon-domo-code-tags',
  },
];
